export default __webpack_public_path__ + "static/KeywordResearch_01_01@2x-2cee9e00dc20e3d5b9fca4d8b64b4091.webp";